import { httpsCallable } from "firebase/functions";
import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral
} from "@fixeduy/restaurantestypes";

interface LoginCodigoMailOTP {
  mail: string;
  tokenNumerico: string;
  tokenDispositivo: string;
}

const loginCodigoMailAcceder = async (
  data: LoginCodigoMailOTP
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "loginCodigoMailAcceder",
    params: data
  });
  return result.data;
};

export { loginCodigoMailAcceder };
